import { Component } from 'react';

class RecoveryByTeamMember extends Component {
  singleColumn(label, index, applyStrongLabels) {
    return (
      <div className="widgetCell" key={`cell-${index}`}>
        <div className="spec-value">
          {applyStrongLabels ? <strong>{label}</strong> : label}
        </div>
      </div>
    );
  }

  render() {
    let { employees, columns } = this.props.data;
    return (
      <div className="flexTable teamTable">
        <div className="widgetRow widgetHeader">
          <div className="widgetCell profile">
            <strong>Name</strong>
          </div>
          {columns.map((label, index) => this.singleColumn(label, index, true))}
        </div>

        {employees.map((ds, index) => (
          <div
            className={`widgetRow spec-${ds.employee_id}`}
            key={`row-${index}`}
          >
            <div className=" widgetCell profile">
              <span className="profile-img">
                <img src={ds.profile.image} />
              </span>
              <span className="profile-name" data-notranslate>
                {ds.profile.name}
              </span>
            </div>
            {ds.dataset.map((arrayOrValue, index) =>
              this.singleColumn(arrayOrValue, index, false),
            )}
          </div>
        ))}
      </div>
    );
  }
}

export default RecoveryByTeamMember;
